import { topics } from '@/mocks/home';

export default function TopicCloud() {
  return (
    <section id="topics" className="bg-background-50 py-10 md:py-16 border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6">
          <div>
            <span className="text-xs font-label tracking-[0.2em] text-primary-600 uppercase">Topic Index</span>
            <h2 className="mt-1.5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">话题索引</h2>
            <p className="mt-1.5 text-sm text-foreground-500">按事件类型归档，数字为该话题下已整理的条目数</p>
          </div>
          <span className="text-xs text-foreground-500 whitespace-nowrap self-start md:self-auto">
            共 {topics.length} 个话题分类
          </span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#feed"
              className="group flex items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3.5 hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <span className="flex items-center gap-2 min-w-0">
                <i className="ri-price-tag-3-line text-primary-500 shrink-0"></i>
                <span className="text-sm text-foreground-800 group-hover:text-primary-700 transition-colors truncate">
                  {topic.name}
                </span>
              </span>
              <span className="text-xs font-label text-foreground-400 shrink-0">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}